import { Grid, GridColumn, GridRow } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

export type SubjectContainerUsedInDataType = {
  uuid: string;
  name: string;
  teachingBlocksCount: number;
  lessonUnitsCount: number;
  lessons: Array<{ uuid: string; displayName: string[] }>;
};

type SubjectContainerUsedInProps = {
  data: SubjectContainerUsedInDataType;
};

export const SubjectContainerUsedIn = ({ data }: SubjectContainerUsedInProps) => {
  const { t } = useTranslation();

  const uniqueLessonDisplayNames = [...new Set(data.lessons.map((lesson) => lesson.displayName.join(', ')))];

  return (
    <>
      {data.teachingBlocksCount > 0 && <div className={'mb-4 mt-4'}>{t('subjectContainer.hasTeachingBlock')}</div>}
      {data.lessonUnitsCount > 0 && <div className={'mb-4 mt-4'}>{t('subjectContainer.hasLessonUnits')}</div>}
      {uniqueLessonDisplayNames.length > 0 && (
        <Grid>
          <GridRow headline={t('usedInLessons', { name: data.name, count: uniqueLessonDisplayNames.length })}>
            <GridColumn width={12}>
              {uniqueLessonDisplayNames.map((dn) => (
                <div key={dn}>{dn}</div>
              ))}
            </GridColumn>
          </GridRow>
        </Grid>
      )}
    </>
  );
};
